import React from 'react';
import PropTypes from 'prop-types';

const CustomPageDetailNavigation = (props) => {

  let {
    pageBlocks,
  } = props;

  const pageBlockNavigation = () => {
    return pageBlocks.map((pageBlock) => {
      return <li key={pageBlock.pageBlockId}>
        <a className="js_scroll" href={`#page_block_${pageBlock.pageBlockId}`}>
          <i className="fa fa-angle-down"></i>{pageBlock.pageBlockTitle}
        </a>
      </li>;
    });
  };

  {
    return (
      <ul className="m_lineList">{pageBlockNavigation()}</ul>
    );
  }
};

CustomPageDetailNavigation.propTypes = {
  pageBlocks: PropTypes.any.isRequired,
};

export default CustomPageDetailNavigation;
